<template>
  <div>
    <div class="city" v-show="parsedAddress.address" @click="clickAdress">
      <icon name="dingwei1" />
      <span class="city-text">{{ parsedAddress.address }}</span>
    </div>
    <NavigationModel
      v-if="parsedAddress.showMap"
      :value="showNavigationSelect"
      @close="showNavigationSelect = false"
      :Address="parsedAddress.face_address"
    />
  </div>
</template>
<script>
import NavigationModel from 'app/frontend-lib/component/Navigation/index.vue'

export default {
  components: {
    NavigationModel
  },
  data() {
    return {
      showNavigationSelect: false
    }
  },
  computed: {
    basicInfo() {
      return this.$store.state.homepage.basicInfo || {}
    },
    parsedAddress() {
      const {
        face_address,
        address = '',
        district = '',
        qing_info = {}
      } = this.basicInfo
      if (face_address && face_address.city) {
        return {
          address: face_address.city,
          showMap: true,
          face_address
        }
      } else {
        const { province = '', city = '' } = qing_info
        return {
          address: address + district || province + city,
          showMap: false
        }
      }
    }
  },
  methods: {
    clickAdress() {
      if (this.parsedAddress.showMap) {
        this.$trackEvent('newprofilepages_address', {})
        this.showNavigationSelect = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~lib/scss/functions.scss';
.city {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 400;
  color: #6c798c;
  line-height: 28px;
  .icon-dingwei1 {
    color: #6c798c;
    font-size: 16px !important;
    margin-right: 4px;
  }
}
</style>
